// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___2bTmZ","heading":"styles__heading___mD4_3","italic":"styles__italic___NkP8B","headerButtons":"styles__headerButtons___3MnEi","headerButtonShare":"styles__headerButtonShare___2ZIlJ"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/header/styles.css
// module id = xNQq
// module chunks = 2